/** Identifier tokens per PaymentReconciliation search, to stay under server URL limits. */
export const LEDGER_IDENTIFIER_CHUNK_SIZE = 20;
